import { Route } from "react-router";
import { SpinnerLegacy } from "../components";
import { RETAILER_HOME } from "../constants/routes";
import type { useAppInitialization } from "../hooks/useAppInitialization";
import { RetailerHome } from "../pages/retailer/RetailerHome";
import { RetailerLayout } from "../pages/retailer/RetailerLayout";
import { RetailerNavigation } from "../pages/retailer/RetailerNavigation";
import { AppFallbackRedirect } from "./AppFallbackRedirect";
import { getRetailerRouteAccess } from "./getRetailerRouteAccess";
import { RouteAccessBoundary } from "./RouteAccessBoundary";

export const renderRetailerRoutes = ({
  initialization,
}: {
  initialization: ReturnType<typeof useAppInitialization>;
}) => {
  const { firebase, sellar, currentBusiness, signup } = initialization;
  const { business } = currentBusiness;
  const access = getRetailerRouteAccess(initialization);
  const hasBusinessSession = Boolean(firebase.user && sellar.user && business);

  return (
    <Route
      element={
        access === "loading" ? (
          <SpinnerLegacy />
        ) : (
          <RouteAccessBoundary
            isAllowed={access === "allowed"}
            renderFallback={() => (
              <AppFallbackRedirect
                hasFirebaseUser={Boolean(firebase.user)}
                sellarUser={sellar.user}
                business={business}
                redirectToMarket={signup.redirectToMarket}
                redirectToSellarCreditOnboarding={
                  signup.redirectToSellarCreditOnboarding
                }
                // A saved Home continuation must not loop back to a denied route.
                ignoreContinuationRedirects={hasBusinessSession}
              />
            )}
          />
        )
      }
    >
      <Route element={<RetailerLayout header={<RetailerNavigation />} />}>
        <Route path={RETAILER_HOME} element={<RetailerHome />} />
      </Route>
    </Route>
  );
};
